import { render, staticRenderFns } from "./HomeSolutionTab.vue?vue&type=template&id=6401f53c&"
import script from "./HomeSolutionTab.vue?vue&type=script&lang=js&"
export * from "./HomeSolutionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports